import "core-js/modules/es.function.name.js";
import React from 'react';
import { Box, makeStyles } from '@applyboard/ui-components';
import ScoreInput from "../ScoreInput";
var useStyles = makeStyles({
  content: {
    margin: '8px 0 0 0'
  }
});
var Score = function Score(props) {
  var error = props.error,
    label = props.label,
    exam = props.exam,
    name = props.name,
    value = props.value,
    onChange = props.onChange,
    _props$section = props.section,
    section = _props$section === void 0 ? '' : _props$section,
    showError = props.showError;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Box, {
    className: classes.content
  }, /*#__PURE__*/React.createElement(ScoreInput, {
    name: name,
    value: value,
    label: label,
    exam: exam,
    onChange: onChange,
    section: section,
    showError: showError,
    errorMessage: error
  }));
};
export default Score;